// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__jf4fb","disabled":"FileBtn_disabled__2XnLe","warn":"FileBtn_warn__3Sq0y","fade":"FileBtn_fade__2189G"};